



























































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import pcCodeStore, { PcCodeStore } from "@/modules/pcCode/services/PcCodeStore";
import store, { MetRiportStore } from "../services/MetRiportStore";
import MetRiportItem from "../models/MetRiportItem";
import globalStore from "@/models/GlobalStore";
import dayjs from "dayjs";

interface Data {
  store: MetRiportStore;
  pcCodeStore: PcCodeStore;
  transactions: any[];
}

interface Methods {
  formatDate(date?: string, time?: string): string;
}

interface Computed {
  columns: ApiSearchColumn[];
  url: string;
  sum: number;
}

interface Props {
  item: MetRiportItem;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    ApiSearchPage,
  },

  props: {
    item: { type: Object, required: true },
  },

  async beforeMount() {
    await pcCodeStore.loadStore();
    pcCodeStore.getDmsNatFromCode(this.item.dmsCode);
  },

  data() {
    return {
      store,
      pcCodeStore,
      globalStore: globalStore,
      transactions: [],
    };
  },

  computed: {
    url() {
      return `met-riport/${this.item.metisHead}/item/details/${this.item.id}/${encodeURIComponent(this.item.dmsCode || "")}`;
    },
    columns: function () {
      return [
        {
          field: "trans",
          title: "Tranzakció azonosító",
          type: ColumnType.Right,
        },
        {
          field: "headAccEvent",
          title: "Esemény",
        },
        {
          field: "headTransTypeName",
          title: "Tranzakció típusa",
        },
        {
          field: "itemPeriodname",
          title: "Periódus",
          type: ColumnType.Right,
          // filterable: false,
        },
        {
          field: "bookinDate",
          title: "Tranzakció ideje",
          cell: "bookinDate",
          // filterable: false,
        },
        {
          field: "itemPartner",
          title: "Partner",
          width: 200,
          // filterable: false,
        },
        {
          field: "prefix",
          title: "Prefix",
        },
        {
          field: "accDate",
          title: "Könyvelés dátuma",
          cell: "accDate",
          // filterable: false,
        },
        {
          field: "itemUser",
          title: "Könyvelte",
          // filterable: false,
        },
        {
          field: "itemBookTypeName",
          title: "Könyvelés típusa",
        },
        {
          field: "headStorno",
          title: "Sztornó tranzakció",
          cell: "headStorno",
          type: ColumnType.Right,
          width: 50,
          // filterable: false,
        },
        {
          field: "itemAccNoVal",
          title: "Fk. szám",
          type: ColumnType.Right,
        },
        {
          field: "itemAccNoName",
          title: "Fk. szám megnevezés",
        },
        {
          field: "accSign",
          title: "T/K",
          cell: "accSign",
          // filterable: false,
        },
        {
          field: "total",
          title: "Könyvelt összeg",
          cell: "total",
          type: ColumnType.Right,
        },
        {
          field: "itemCarName",
          title: "Kapcsolódó gépjármű",
        },
        {
          field: "k2DInvNo",
          title: "Kapcsolódó számla",
          // filterable: false,
        },
        {
          field: "headStoreIn",
          title: "Betárolás",
          type: ColumnType.Right,
        },
        {
          field: "headStoreOut",
          title: "Kitárolás",
          type: ColumnType.Right,
        },
      ];
    },
    sum() {
      return this.transactions.reduce((acc, item) => acc + item.total, 0);
    },
  },

  methods: {
    formatDate(date, time = "") {
      return `${dayjs(date).format("YYYY.MM.DD")}${time !== "" ? ` ${(time || "").substring(11, 16)}` : ``}`
    },
  },
});
